// extracted by mini-css-extract-plugin
export default {"Inscription":"Inscription_Inscription__XlE+-","Formulaire":"Inscription_Formulaire__Rx8n0","Centre":"Inscription_Centre__3ZXIC"};